export const decodeProgramSheetParams = (value: string) => {
  let sid = 0;
  let eventId = 0;
  let contentId = 0;
  let contentType = '';
  let subProviderId = '';
  let universeId = '';
  let provider = '';

  if (value) {
    const params = new URLSearchParams(value);
    sid = Number(params.get('sid'));
    eventId = Number(params.get('eid'));
    contentId = Number(params.get('cid'));
    contentType = params.get('ctype') ?? '';
    subProviderId = params.get('spid') ?? '';
    universeId = params.get('uid') ?? '';
    provider = params.get('prov') ?? '';
  }

  return { sid, eventId, contentId, contentType, subProviderId, universeId, provider };
};

export default decodeProgramSheetParams;
